export default __webpack_public_path__ + "9bc4790d1f40493e9e5edc66e9dd6d22.otf";